<label class="container">
    <input [formControlName]="name" type="checkbox" />
    <span class="checkmark"></span>
    <div>
        <div style="display: flex; align-items: center; gap: 7px">
            <div style="font-size: 16; white-space: nowrap">
                {{ label }}
            </div>
        </div>
    </div>
</label>
